/**
 * Renders the flow for a slug using static `createElement` per case (required by
 * react-hooks/static-components). Only imported by the add-to-cart page,
 * so product pages don't bundle these components.
 *
 * Keep `case` labels in sync with keys in `lib/config/customAddToCartFlows` `flowMetadata`
 * (server validates metadata; a missing case here yields client `notFound()`).
 * Flows: `vorst-bosch`, `hybrid-cup`, `add-misc`.
 */

import { createElement, type ReactElement } from 'react'
import type { CustomAddToCartFlowProps } from '@/lib/config/customAddToCartFlows'
import { AddMiscAddToCart } from './flows/AddMiscAddToCart'
import { HybridCupAddToCart } from './flows/HybridCupAddToCart'
import { VorstBoschAddToCart } from './flows/VorstBoschAddToCart'

export function renderCustomAddToCartFlow(
  props: CustomAddToCartFlowProps
): ReactElement | null {
  switch (props.flowSlug) {
    case 'vorst-bosch':
      return createElement(VorstBoschAddToCart, props)
    case 'hybrid-cup':
      return createElement(HybridCupAddToCart, props)
    case 'add-misc':
      return createElement(AddMiscAddToCart, props)
    default:
      return null
  }
}
